import { invert } from "lodash";

const relationship_icon_labels = {
  CIRCLE: "circle",
  SQUARE: "square",
  FILLED: "filled"
};

const relationshipSvgToClass = {
  circle: "circle",
  square: "square",
  "circle-f": "circle filled",
  "square-f": "square filled"
};

const relationshipClassToSvg = invert(relationshipSvgToClass);

export { relationship_icon_labels, relationshipClassToSvg,relationshipSvgToClass };
